// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13ZZl","left":"styles_left__13_TZ","desktopActions":"styles_desktopActions__2nR_e","title":"styles_title__XGRJ1"};